<template>
  <b-card class="mobile-card">
    <b-container v-b-toggle="`apport_${item.numeroApport}`">
      <b-row align-v="center">
        <b-col cols="auto" class="bg-light bg-left font-up" style="width: 80px">
          <div class="w-100">
            {{ jour }}/{{ mois }}<br />
            {{ annee }}
          </div>
        </b-col>
        <b-col>
          <b-row class="m-0" align-v="center">
            <b-col class="p-0">
              <div>
                {{ item.libelleProduit }}
              </div>
              <div class="font-down">
                <MontantComponent
                  :value="item.poidsLivre"
                  :options="{ minimumFractionDigits: 0 }"
                ></MontantComponent>
                t brut - {{ item.numeroApport }}
              </div>
              <b-collapse
                :id="`apport_${item.numeroApport}`"
                class="label font-down text-center"
                visible
              >
                <b-icon-chevron-down></b-icon-chevron-down>
                Caract&eacute;ristiques
              </b-collapse>
            </b-col>
            <b-col cols="auto" v-if="item.pieceJointe" @click.stop>
              <DownloadComponent
                :typeDocument="typeDocument"
                :targetId="item.numeroApport"
              ></DownloadComponent>
            </b-col>
          </b-row>
          <b-collapse :id="`apport_${item.numeroApport}`">
            <b-row class="m-0 mt-2 font-down">
              <b-col cols="2" class="p-0">Net</b-col>
              <b-col cols="4" class="p-0">
                <MontantComponent
                  :value="item.poidsAuxNormes"
                  :options="{ minimumFractionDigits: 0 }"
                ></MontantComponent>
                t
              </b-col>
              <b-col cols="2" class="p-0">PS</b-col>
              <b-col cols="4" class="p-0">
                <MontantComponent
                  :value="item.poidsSpecifique"
                  :options="{ minimumFractionDigits: 0 }"
                ></MontantComponent>
                kg/hL
              </b-col>
              <b-col cols="2" class="p-0">Hum.</b-col>
              <b-col cols="4" class="p-0">
                <MontantComponent
                  :value="item.tauxHumidite"
                  :options="{ minimumFractionDigits: 0 }"
                ></MontantComponent>
                %
              </b-col>
              <b-col cols="2" class="p-0">Imp.</b-col>
              <b-col cols="4" class="p-0">
                <MontantComponent
                  :value="item.tauxImpurete"
                  :options="{ minimumFractionDigits: 0 }"
                ></MontantComponent>
                %
              </b-col>
            </b-row>
          </b-collapse>
        </b-col>
      </b-row>
    </b-container>
  </b-card>
</template>

<script>
import MontantComponent from "../MontantComponent.vue";
import DownloadComponent from "../controls/DownloadComponent.vue";
export default {
  name: "BonApportCard",
  components: { MontantComponent, DownloadComponent },
  props: ["item"],
  data() {
    return {
      typeDocument: this.$store.state.expl.typesDocument.BON_APPORT,
    };
  },
  computed: {
    jour() {
      return this.item.dateApport.split("-")[2];
    },
    mois() {
      return this.item.dateApport.split("-")[1];
    },
    annee() {
      return this.item.dateApport.split("-")[0];
    },
  },
};
</script>
